import React, { memo } from 'react';
import FormField from '@active/react-ui/FormField';
import FormGroup from '@active/react-ui/FormGroup';
import CurrencyInput from '@active/react-ui/CurrencyInput';
import useCrurrencyInput from '../../../utils/useCrurrencyInput';

const CurrencyInputField = ({
  disabled, name, paymentAccountId, paymentMethodType, isPrefillValue, onChange,
}) => {
  const {
    currencyCode,
    placeholder,
    handleFocus,
    handleBlur,
    handleChange,
  } = useCrurrencyInput({
    paymentAccountId, paymentMethodType, isPrefillValue, onChange,
  });

  return <FormGroup name={name}>
    <FormField
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      disabled={disabled}
      placeholder={placeholder}
      as={CurrencyInput}
      maxlength="50"
      autoComplete="off"
      codePosition="prefix"
      code={currencyCode}/>
  </FormGroup>;
};

export default memo(CurrencyInputField);
